// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { HasOnError, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { get } from "@insite/client-framework/Services/ApiService";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";

interface DigitalLineCardDataBrand {
    id: string;
    name: string;
    logoImagePath: string;
    siteUrl: string;
}

interface DigitalLineCardDataSubCategory {
    id: string;
    name: string;
    subCategories: any;
}

export interface DigitalLineCardDataCategory {
    id: string;
    name: string;
    subCategories?: DigitalLineCardDataSubCategory[];
}

export interface DigitalLineCardData {
    websiteId: string;
    brands: DigitalLineCardDataBrand[];
    categories: DigitalLineCardDataCategory[];
}

const serviceUrl = "api/mcmc/v2/linecard";
export interface DigitalLineCardParameter {
    categoryId: string;
    widgetId: string;
}

export function getDigitalLineCardDataService({ categoryId }: Pick<Partial<DigitalLineCardParameter>, "categoryId">) {
    return get<DigitalLineCardData>(
        `${serviceUrl}/categories${categoryId && categoryId !== `all` ? `/${categoryId}` : ``}`,
    );
}
